<template>
  <div>
    <!-- filter header -->
    <div class="row">
      <div class="col-sm-3">
        <h5 class="_300 margin">Vouchers</h5>
      </div>

      <div class="col-sm-3 pull-right">
        <outlet-selector :outlet="$store.state.report.activeOutlet"/>
      </div>
    </div>

    <div class="box">
      <v-server-table 
        ref="datatable" 
        :url="api" 
        :name="tableName" 
        :columns="columns" 
        :options="options"/>
         
      <!-- modal -->
      <div 
        id="coupon-popup" 
        class="modal fade active" 
        data-backdrop="false">
        <div class="right w-xxxl white b-l">
          <vuetablecoupon_form 
            ref="couponform" 
            :coupon="coupon" 
            :meta="meta"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from '@js/plugins/auth';
import VuetableCheckbox from '../../../components/vuetable2/checkbox/state';
import { EventCoupon } from './coupon-event-bus';
import lodash from 'lodash';

const TableName = 'VUETABLE_COUPON';

export default {
    data: function() {
        let canManageCoupons = Auth.hasPermissionTo(
            'franchise_manage_marketing',
        );

        let actionButtons = [
            {
                title: 'Create Voucher',
                action: () => this.show_popup(null),
            },
        ];

        if (!canManageCoupons) {
            actionButtons = [];
        }

        var that = this;

        return {
            coupon: {},
            meta: {},
            tableName: TableName,
            api: Laroute.route('franchise.inventory.coupon.index'),
            columns: [
                'name',
                'available_from',
                'revenue',
                'sold',
                'redeemed',
                'remaining',
                'price',
                'value',
                'status',
            ],
            options: {
                checkbox: canManageCoupons,

                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.inventory.coupon.delete',
                    ),
                    delete_title: 'Delete Coupons',
                },

                actionButtons: actionButtons,

                customFilters: ['outlet_id'],

                initFilters: { outlet_id: that.$store.getters.activeOutlet },

                sortable: [
                    'name',
                    'available_from',
                    'price',
                    'value',
                    'status',
                ],

                orderBy: { column: 'name', ascending: 1 },

                headings: {
                    name: 'Name',
                    price: 'Price',
                    value: 'Value',
                    available_from: 'Redeemable Dates',
                    status: 'Status',
                    actions: '',
                },

                templates: {
                    revenue(h, row) {
                        row.revenue = that.getCouponRevenue(row);
                        return require('./revenue.jsx')(h, row, that);
                    },
                    sold(h, row) {
                        row.sold = that.getCouponSold(row);
                        return require('./sold.jsx')(h, row, that);
                    },
                    redeemed(h, row) {
                        row.redeemed = that.getRedeemedCodes(row).length;
                        return require('./redeemed.jsx')(h, row, that);
                    },
                    remaining(h, row) {
                        if (row.limit_sale == 1) {
                            let sold = that.getCouponSold(row);

                            row.remaining = row.limit_quantity - sold;
                            row.remaining_low =
                                (row.remaining / row.limit_quantity) * 100 <= 20
                                    ? true
                                    : false;
                            row.remaining_text =
                                row.remaining + ' / ' + row.limit_quantity;
                        } else {
                            row.remaining_low = false;
                        }
                        return require('./remaining.jsx')(h, row, that);
                    },
                    price(h, row) {
                        return require('./price.jsx')(h, row, that);
                    },
                    value(h, row) {
                        return require('./value.jsx')(h, row, that);
                    },
                    available_from(h, row) {
                        return require('./available_from_date.jsx')(
                            h,
                            row,
                            that,
                        );
                    },
                    status(h, row) {
                        return require('./status.jsx')(h, row, that);
                    },
                },

                csv_url: Laroute.route(
                    'franchise.inventory.coupon.exportAsFile',
                    { type: 'CSV' },
                ),

                pdf_url: Laroute.route(
                    'franchise.inventory.coupon.exportAsFile',
                    { type: 'PDF' },
                ),

                rowClassCallback: row => 'pointer',
                rowClickCallback: that.show_popup,
            },
        };
    },
    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },

        searchQuery() {
            return this.$refs.datatable.query;
        },
    },

    watch: {
        activeOutlet: function() {
            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'outlet_id',
                value: this.activeOutlet,
            });
        },
    },

    created() {
        this.$store.registerModule(`CHECKBOX_${TableName}`, VuetableCheckbox);
        this.initCoupon();
        this.init();
    },

    methods: {
        init() {
            setTimeout(() => {
                EventCoupon.$emit('loaded');
            }, 100);
        },

        initCoupon() {
            (this.coupon = {
                name: '',
                description: '',
                status: true,
                limit_sale: false,
                limit_quantity: 0,
                outlet_id: this.activeOutlet,
                what_you_get: '',
                fineprint: '',
                price: '0.00',
                value: '0.00',
                media_urls: [],
                available_from: null,
                available_to: null,
                outlets: [],
                products: [],
                tags: [],
                taxes: [],
            }),
                (this.meta = {});
        },

        getCoupon(id) {
            var that = this;
            this.$http.get(this.getCouponApi(id)).then(response => {
                let data = response.data;
                that.coupon = data.data;
                that.meta.franchise = data.franchise;
                that.meta.bought = data.bought;
                if (that.coupon.outlet_id == null) {
                    that.coupon.outlet_id = 0;
                }
                that.show_modal();
            });
        },

        show_popup(row) {
            if (row == null) {
                this.initCoupon();
                this.show_modal();
                this.$refs.couponform.resetTemplate();
            } else {
                this.getCoupon(row.id);
                this.$refs.couponform.resetTemplate();
            }
        },

        getCouponApi(id) {
            return Laroute.route('franchise.inventory.coupon.show', { id: id });
        },

        show_modal() {
            $('#coupon-popup').modal('show');
        },

        hide_modal() {
            $('#coupon-popup').modal('hide');
        },

        refresh() {
            this.$refs.datatable.setFilter(this.searchQuery);
        },

        getRedeemedCodes(row) {
            return lodash.filter(row.redemptions, r => {
                return r.redeemed_at;
            });
        },

        getPaidInvoices(row) {
            return lodash.filter(row.invoices, i => {
                return i.paid_at;
            });
        },

        getCouponSold(row) {
            let paid_invoices = this.getPaidInvoices(row);

            return lodash.sumBy(paid_invoices, i => {
                return i.quantity;
            });
        },

        getCouponRevenue(row) {
            return row.price * this.getCouponSold(row);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/coupon/vuetable_coupon.vue